import {createContext, useState} from 'react';

const LoopMetadata = createContext({
    data: {},
    updateData: () => {},
});
LoopMetadata.displayName = 'LoopMetadata';

const LoopMetadataProvider = ({children}) => {
    const [data, setData] = useState({});
    const updateData = delta => {
        setData(prevData => ({
            ...prevData,
            ...delta,
        }));
    };
    const clearData = () => {
        setData({});
    };

    return (
        <LoopMetadata.Provider
            value={{
                data,
                updateData,
                clearData,
            }}
        >
            {children}
        </LoopMetadata.Provider>
    );
};

export default LoopMetadataProvider;
export {LoopMetadata};
